<template>
  <div id="app" class="row vert-offset-top-1">
    <div class="row justify-content-center">
      <div class="col s12 m10 l8 offset-m1 offset-l2">
        <div id="card" class="card col s12 vert-offset-top-1 z-depth-3">
          <div
            class="card-title center padding-top-half padding-bottom-half border-bottom-1 grey-border border-lighten-2"
          >
            <h6 class="grey-text text-darken-3">
              Select one or more Tebelopele Service(s) you will like access this
              time around
            </h6>
          </div>
          <div
            class="col s12 m10 offset-m1 padding-top-half padding-bottom-half left-align"
          >
            <div v-for="(item, index) in services" :key="index" class="col s12">
              <p class="vert-offset-top-0">
                <label class="font-12">
                  <input
                    type="checkbox"
                    :value="item.key"
                    :checked="isSelectedService(item)"
                    :key="index"
                    @click="selectService(item)"
                  />
                  <span v-html="item.name" class="bold black-text"></span>
                </label>
              </p>
            </div>
            <div class="col s12 font-14 padding-top-1 padding-bottom-1">
              NB:<span class="red-text font-12">
                The Center you selected provides the following services, if you
                prefer other services, please go back and select a different
                Center or book again.
              </span>
            </div>
          </div>
          <div
            class="col s12 padding-bottom-half vert-offset-top-2 grey-border border-top-1 border-lighten-3 padding-top-1"
          >
            <div class="col s4 padding-bottom-1 padding-top-1">
              <button
                type="submit"
                @click="goback"
                class="btn btn-small btn-block orange darken-1  white-text col s12"
              >
                back
              </button>
            </div>
            <div class="col s4 offset-s4 padding-bottom-1 padding-top-1">
              <button
                type="submit"
                @click="goto"
                class="btn btn-small btn-block orange darken-1  white-text col s12"
                :disabled="counter <= 0"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import InputComponent from "@/components/materiallize/InputComponent";
import http from "@/http-common";
import { mapState } from "vuex";

export default {
  name: "Schedule",
  components: {
    //InputComponent
  },
  data() {
    return {
      counter: 0,
      districts: [],
      centers: [],
      apointments: [],
      item: [],
      list_services: [],
      services: []
    };
  },
  methods: {
    isSelectedService: function(_item) {
      return (
        typeof this.list_services !== "undefined" &&
        this.list_services !== null &&
        this.list_services.indexOf(_item) >= 0
      );
    },
    goto() {
      this.$store.dispatch("SET_SELECTED_SERVICES", this.list_services);
      this.$router.push("/usercontactdetails");
    },
    goback() {
      this.$router.push("/schedule");
    },
    selectService: function(_selected_service) {
      if (
        typeof _selected_service === "undefined" ||
        _selected_service === null
      ) {
        return false;
      }

      if (this.list_services.indexOf(_selected_service) >= 0) {
        this.counter--;
        this.list_services.splice(
          this.list_services.indexOf(_selected_service),
          1
        );
      } else {
        this.counter++;
        this.list_services.push(_selected_service);
      }
    },
    getServiceslist: function() {
      this.$store.dispatch("START_PROCESSING");
      return new Promise(resolve => {
        http({
          url: "api/service",
          data: {
            center: this.stateSelectedCenter.value
          },
          method: "POST",
          timeout: 30000
        })
          .then(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.services = response.data.data;

            /* window.console.log("SELECTED SERVICES-----------------------");
              window.console.log(JSON.stringify(this.stateSelectedServices));
              window.console.log("-----------------------");*/
            if (this.stateHasSelectedServices) {
              let _i;
              for (_i = 0; _i < this.stateSelectedServices.length; _i++) {
                this.selectService(this.stateSelectedServices[_i]);
              }
            }

            resolve(response);
          })
          .catch(response => {
            this.$store.dispatch("STOP_PROCESSING");
            this.$store.dispatch("GET_MESSAGES", response.data.message);
            resolve(response);
          });
      });
    },
    mustRedirectHome: function() {
      if (
        !this
          .stateHasSelectedCenter /*|| !this.stateHasSelectedDistrict*/ /*|| ! this.stateHasSelectedLocation*/
      ) {
        return true;
      }
      return false;
    }
  },
  created() {
    this.getServiceslist();
  },
  mounted() {
    if (this.mustRedirectHome()) {
      this.$router.push("/");
    }
  },
  computed: {
    ...mapState({
      stateSelectedDistrict: state => state.selectedDistrict,
      stateSelectedCenter: state => state.selectedCenter,
      stateSelectedLocation: state => state.selectedLocation,
      stateSelectedServices: state => state.selectedServices
    }),
    prefs: function() {
      var d = {
        storedDistrict: this.districts,
        storedLocation: this.location
      };
      localStorage.setItem("myInput", JSON.stringify(d));
      return d;
    },
    stateHasSelectedDistrict: function() {
      return (
        typeof this.stateSelectedDistrict !== "undefined" &&
        this.stateSelectedDistrict !== null
      );
    },
    stateHasSelectedLocation: function() {
      return (
        typeof this.stateSelectedLocation !== "undefined" &&
        this.stateSelectedLocation !== null
      );
    },
    stateHasSelectedCenter: function() {
      return (
        typeof this.stateSelectedCenter !== "undefined" &&
        this.stateSelectedCenter !== null
      );
    },
    stateHasSelectedServices: function() {
      return (
        typeof this.stateSelectedServices !== "undefined" &&
        this.stateSelectedServices !== null
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-kerning: normal;
}
</style>
